import React, { Component } from 'react';
import {Link} from "react-router-dom";
import StepBar from "../StepBar/StepBar";
import Step from "../Step/Step";
import request from "../../Ajax";
import Loader from "../Loader/Loader";

export default class PaymentResponse extends Component {

    constructor(props) {
        super(props);

        this.state = {
            response:'',
            isFetching: true,
            labels: [],
            lang: this.props.match.params.lang === 'en' ? 2 : 1
        };

        this.inner_state = {
            getOrderStatus: 'getOrderStatus',
            labels: 'getLabels',
        };


    }


  error = ()=> {
    return <>
        <div className="title-lg text-uppercase custom-headline main_page_title sm-title">
            <h1>
                {this.state.labels.title_error}
            </h1>
        </div>

        <div className="main_page_link">
            <Link to="/insurance" className="btn btn-green btn-lg">
                {this.state.labels.button_error}
            </Link>
        </div>

        <div className="main_page_img">
            <img src={require("../../assets/img/fail.png")} alt="" />
        </div>
    </>
  };

  success = () => {
      return <>
          <div className="title-lg text-uppercase custom-headline main_page_title sm-title">
              <h1>
                  {this.state.labels.title_success}
              </h1>
          </div>

          <div className="main_page_link">
              <Link to="/" className="btn btn-green btn-lg">
                  Վերադառնալ գլխավոր էջ
              </Link>
          </div>

          <div className="main_page_img">
              <img src={require("../../assets/img/success.png")} alt="" />
          </div>
      </>
  };

   componentDidMount() {

       let url = new URL(window.location.href);
       let orderId = url.searchParams.get("orderId");



       request(
           this.inner_state.labels,
           'post',
           { 'page_type' : 'response', 'lang' : this.state.lang },
           (response) => {
               if (response.data.status === true) {
                   this.setState({ labels: response.data.data },
					   ()=>{
						  request(
							   this.inner_state.getOrderStatus,
							   'post',
							   { orderId : orderId },
							   (response) => {
								   if (response.data.status === true) {
										this.setState({ response : this.success(), isFetching : false})
								   } else {
									   this.setState({ response : this.error(), isFetching : false})

								   }
							   }
						   );
					   }
				   );
               } else {
                   //todo chgitem inch erb labelneri het kapvac xndir ka
               }
           }
       );
   }


  render() {

    return (
        <>

            {
                this.state.isFetching ? <Loader/> :

            <div className="row align-center">
                <div className="column small-12">
                    <StepBar>
                        <Step inner="1" done />
                        <Step inner="2" done />
                        <Step inner="3" done />
                        <Step inner="4" done />
                        <Step inner="5" done />
                        <Step inner="6" active />
                    </StepBar>
                </div>

                <div className="column small-12 large-10">

                    <div className="main_page error_page">
                        <div className="row align-center">
                            <div className="column small-12 large-9">
                                <div className="base_grid_container">
                                    {  this.state.response }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            }

        </>
    )
  }
}
